import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  modal: {
    width: 720
  },
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    lineHeight: 1.4,
    marginBottom: theme.spacing(6)
  },
  optionCards: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  optionCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    backgroundColor: theme.colorPalette.beige_50,
    borderRadius: 4,
    padding: theme.spacing(6),
    gap: theme.spacing(4)
  },
  optionCardMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(4)
  },
  optionText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flex: '1 1 0',
    minWidth: 0
  },
  optionTitle: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    color: theme.colorPalette.green_80
  },
  optionDescription: {
    color: theme.colorPalette.green_100
  },
  actionButton: {
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 16,
    padding: theme.spacing(2, 4),
    borderRadius: 4,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    gap: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.colorPalette.green_90
    }
  },
  cardFooter: {
    borderTop: `1px solid ${theme.colorPalette.beige_60}`,
    paddingTop: theme.spacing(4)
  },
  cardFooterContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  alertIcon: {
    flexShrink: 0
  },
  cardFooterText: {
    fontSize: 12,
    lineHeight: 1.5,
    color: theme.colorPalette.green_100
  },
  generatingPdfText: {
    fontWeight: 400,
    fontSize: 12,
    color: theme.colorPalette.orange_50
  },
  footerLink: {
    fontWeight: 400,
    fontSize: 12,
    color: theme.colorPalette.orange_50,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  downloadButton: {
    width: 205
  },
  buttonIcon: {
    paddingRight: theme.spacing(1)
  }
});

export default makeStyles(styles);
